import { PROJECT_REPORT_STATUSES } from "@/app/projects/constants";
import isStatus from "./is-status";

export const isProjectReportGenerating = (project) =>
  isProjectReportStatus(project, "generating");

export const hasProjectReportGenerated = (project) =>
  isProjectReportStatus(project, "generated");

export const hasProjectReportFinished = (project) =>
  isProjectReportStatus(project, "failed", "generated");

export const hasProjectReportFailed = (project) =>
  isProjectReportStatus(project, "failed");

export const isProjectReportStatus = (project, ...expectations) =>
  isStatus(PROJECT_REPORT_STATUSES, project, "promptStatus", ...expectations);
